<template>
    <div>
        <div class="el-input--mini el-input client-select-dialog" :clientName="clientName" :clientCode="clientCode" size="mini" :readonly="true">
            <span class="el-input__inner" style="display: flex;">
                <span class="wrap-text" style="flex: 1;">{{myClientName}}</span>
                <span class="el-input__icon input-inner-suffix" v-on:click="selectClient" style="width: auto; padding-left: 10px;padding-right: 5px;">选择客户</span>
            </span>
        </div>
        <dialog-table ref="clientDialog" :title="title" :tableList="tableList">
            <template v-slot:searchForm>
                <el-form-item label="" style="margin-right: 10px;">
                    <el-input v-model="tableList.searchForm.keywords" placeholder="关键词" clearable @keyup.enter.native="$refs.clientDialog.load();"></el-input>
                </el-form-item>
            </template>
            <template v-slot:tableColumns>
                <el-table-column
                    property="name" label="客户名称"></el-table-column>
                <el-table-column property="code" label="客户编码"></el-table-column>
                <el-table-column
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="chooseClient(scope.row, scope.$index)">选择</el-button>
                    </template>
                </el-table-column>
            </template>
        </dialog-table>
    </div>
</template>

<script>
    export default {
        name: "ClientSelectDialog",
        props: {
            value: [Number, String],
            clientName: [Number, String],
            clientCode: [Number, String],
            permissionId: String,
            tableList: Object,
            title: {
                type: String,
                value: "请选择客户",
            }
        },
        data() {
            return {
                clientId: this.value,
                myClientName: this.clientName,
                myClientCode: this.clientCode,
            };
        },
        mounted(e) {
            console.log("ClientSelectDialog mounted", this.value, this.clientName, this.clientCode);
        },
        computed: {
            isPermit() {
                return this.hasPermission(this.permissionId);
            },
            clientNameAndCode() {
                return `${(this.isPermit ? this.myClientName : '')} ${this.myClientCode}`;
            }
        },
        methods: {
            selectClient()
            {
                this.$refs.clientDialog.show();
            },
            chooseClient(client, index)
            {
                console.log("chooseClient", client, index);
                this.clientId = client.id;
                this.myClientName = client.name;
                this.myClientCode = client.code;

                this.$refs.clientDialog.hide();
                this.$emit("input", this.clientId);
                this.$emit("chooseClient", client);
            }
        },
        watch: {
            clientName: function(newV, oldV) {
                // console.log("watch clientName change >>>", newV, oldV);
                this.myClientName = newV;
            },
            clientCode: function(newV, oldV) {
                this.myClientCode = newV;
            }
        }
    }
</script>

<style scoped>
    .client-select-dialog {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/modules/erp/components/form/ClientSelectDialog.vue